import React from 'react'
import './Trusted.css'
import Zoom from '../../assests/zoom-logo-svg-150px.png'
import Discord from '../../assests/discord-logo-svg-150px.png'
import Dropbox from '../../assests/dropbox-logo-svg-150px.png'
import Pinterest from '../../assests/pinterest-logo-svg-150px.png'

const Trusted = () => {
  return (
    <div className='trusted-partners'>
      <h2>Our Trusted Partners</h2>
      <p>
        Many companies have tried using <span>SendCheap</span> and they trust <br /> the safety of their money
      </p>
      <div className="trusted-partners-logo">
        <div className='logos'>
            <img src={Pinterest} alt="" />
        </div>
        <div className='logos'>
            <img src={Zoom} alt="" />
        </div>
        <div className='logos'>
            <img src={Discord} alt="" />
        </div>
        <div className='logos'>
            <img src={Dropbox} alt="" />
        </div>
       </div>
    </div>
  )
}

export default Trusted
